import { NotificationName } from 'typings/enums';
import { NotificationItemPromotionRequest } from 'nomst/Stores/Notification/notificationItemPromotionRequest';

export class NotificationItemPromotionRequestForReview extends NotificationItemPromotionRequest {

    declare data: INotificationDataPromotionRequestForReview;

    constructor(props: IBaseNotificationItem) {
        super(props);
        this.notificationName = NotificationName.NotificationDataPromotionRequestForReview;
    }

    get iconCss(): string {
        return 'icon-paper-plane';
    }
    get titleText(): string {
        return `Review promotion request - ${this.data.employeeName}`;
    }
    get contentText(): string {
        return `Send for review by ${this.data.sentBy}`;
    }
}